import React, { FC, memo } from 'react';
import { Typography } from 'udesk-ui';
import styled from 'styled-components';

const EllipsisTooltip = styled.div`
    white-space: pre-wrap;
    word-break: break-word;
`;

interface TemplateProps {
    style?: React.CSSProperties;
    text?: string;
    suffix?: string;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { style, text, suffix } = props;

    return (
        <Typography.Text
            style={{ width: '100%', textAlign: 'left', wordBreak: 'break-all', ...style }}
            ellipsis={{
                tooltip: <EllipsisTooltip>{text}</EllipsisTooltip>,
                suffix,
            }}
        >
            {text}
        </Typography.Text>
    );
});

export default Template;
